import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

/**
 * Fetch a user's current pill coin balance (admin).
 * @param {string} userId - target user id (UUID)
 */
const GetCoinBalance = (userId) => {
  return useQuery(
    ["get-coin-balance", userId],
    () =>
      request({
        url: `/coin/admin/balance/${userId}`,
        method: "GET",
      }),
    {
      enabled: !!userId,
    }
  );
};

export default GetCoinBalance;
